(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/store/redux.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/store/redux.js');
"use strict";


const {
  reducer: pdReducer
} = svs.myProfile.react.store.pd;
const {
  reducer: pdPreferencesReducer
} = svs.myProfile.react.store.pdPreferences;
const reducerObject = {
  playerDetails: pdReducer,
  playerCustomizedSettings: pdPreferencesReducer
};

svs.myProfile.react.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: reducerObject,
    preloadedState: preloaded
  });
};
const store = svs.myProfile.react.store.createStore();
const PlayerDetailsReduxProvider = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.myProfile.react.store.PlayerDetailsReduxProvider = PlayerDetailsReduxProvider;

 })(window);